import httpService from '@/core/http/http.service';
import { createUrlFactory, shouldExclude } from '@/project/http/ApiHelper.service';
import {
    CategoryTreeViewModel,
    FacetsViewModel,
    ProductIdsViewModel,
    SearchRequest,
    SearchViewModel
} from '@/types/apiServerContract';
import { omitBy } from 'lodash';
import { UrlFacets } from '@/core/urlHelper.service';

export class SearchController {
    readonly urlFactory = createUrlFactory('Search');

    public async search(searchRequest: SearchRequest, selectedFacets: UrlFacets, contextKey: string): Promise<SearchViewModel> {
        // Remove parameters that are empty, null or undefined
        const params = omitBy({ ...searchRequest, ...selectedFacets }, shouldExclude);
        return httpService.get(this.urlFactory('Search'), params, contextKey);
    }

    public async facets(searchRequest: SearchRequest, selectedFacets: UrlFacets, contextKey: string): Promise<FacetsViewModel> {
        // Remove parameters that are empty, null or undefined
        const params = omitBy({ ...searchRequest, ...selectedFacets }, shouldExclude);
        return httpService.get(this.urlFactory('Facets'), params, contextKey);
    }

    public async raw(searchRequest: SearchRequest, selectedFacets: UrlFacets): Promise<string> {
        // Remove parameters that are empty, null or undefined
        const params = omitBy({ ...searchRequest, ...selectedFacets }, shouldExclude);
        return httpService.get(this.urlFactory('Raw'), params);
    }

    public async clearBoostCache(): Promise<string> {
        return httpService.get(this.urlFactory('ClearBoostCache'));
    }

    public async productIds(searchRequest: SearchRequest, selectedFacets: UrlFacets): Promise<ProductIdsViewModel> {
        // Remove parameters that are empty, null or undefined
        const params = omitBy({ ...searchRequest, ...selectedFacets }, shouldExclude);
        return httpService.get(this.urlFactory('GetProductIds'), params);
    }

    public async categories(searchRequest: SearchRequest, selectedFacets: UrlFacets, contextKey: string): Promise<CategoryTreeViewModel> {
        // Remove parameters that are empty, null or undefined
        const params = omitBy({ ...searchRequest, ...selectedFacets }, shouldExclude);
        return httpService.get(this.urlFactory('Categories'), params, contextKey);
    }

    public async requestProductExport(searchRequest: SearchRequest, searchUri: string, icecatMode: boolean, selectedFacets: UrlFacets): Promise<void> {
        // Remove parameters that are empty, null or undefined
        const params = omitBy({ ...searchRequest, ...selectedFacets, searchUri, icecatMode }, shouldExclude);
        return httpService.get(this.urlFactory('RequestProductExport'), params);
    }
}
